import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const loadRoomTree1 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getVisibleTree/v2',
    Object.assign({}, options, {
      params
    })
  );

//房产树一级节点
export const loadPayablePage = (params, options) =>
  request.get(
    '/api/v4ward/fund/bill/payablePage/v2',
    Object.assign({}, options, {
      params
    })
  );


//房产树子节点
export const loadRoomTree2 = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getChildrenNode/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取科目列表
export const getSubjectList = (params, options) =>
  request.get('/api/v4ward/fee/subject/getSubjectList/v2?status=1', Object.assign({}, options, {
    params
  }));

// //获取收费科目列表字典值
// export const getSubjectListByDict = (params, options) =>
// request.get('/api/v4ward/fee/subject/getSubjectList', Object.assign({}, options, { params }));


//住户信息
export const loadZhxx = (params, options) =>
  request.get(
    '/api/propertyCharges/household/getHouseholdByCodeOrId/v2',
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const loadCommunityList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/client/wx/public/communityList/v2",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const loadBuildingList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/client/wx/public/buildingList",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const loadRoomList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/client/wx/public/roomList/v2",
    Object.assign({}, options, {
      params
    })
  );


//收款方式
export const getPayTypeList = (params = {}, options = {}) =>
  request.get(
    "/api/propertyCharges/pay/paylist/v2",
    Object.assign({}, options, {
      params
    })
  );
// 收款方式for车场
export const getPayTypeListforSpaceId = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/car/CarMonth/monthPayType/v2",
    Object.assign({}, options, {
      params
    })
  );
//小区下拉框
export const getPaySceneList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v2/getPayScene",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const getPaySceneListNew = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v1/getPayScene/v2",
    Object.assign({}, options, {
      params
    })
  );


//物业收费二维码支付
export const saveQrCodePay = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billpay/v2', params, options);


//小区下拉框
export const loadPayStatusPlatform = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v2/queryplatform/v2",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const loadPayStatusChannel = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v2/querychannel/v2",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const loadPayStatusPlatformV1 = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v1/queryplatform/v2",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const loadPayStatusChannelV1 = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/propertypay/v1/querychannel/v2",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const getArrears = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/fund/bill/getArrears/v2",
    Object.assign({}, options, {
      params
    })
  );

//小区下拉框
export const getCouponList = (params = {}, options = {}) =>
  request.get(
    "/api/v4ward/fund/preferent/getList/v2",
    Object.assign({}, options, {
      params
    })
  );

//获取小区
export const getNode = (params, options) =>
  request.get('api/base/property/optionNode/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取小区
export const getVisibleTree = (params, options) =>
  request.get('api/base/property/optionNode/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取优惠政策
export const getPreferentList = (params, options) =>
  request.get('api/v4ward/fund/preferent/getList/v2',
    Object.assign({}, options, {
      params
    })
  );

// 字典
export const getDict = (params, options) =>
  request.get('/api/blade-system/dict/dictionary/v2', Object.assign({}, options, {
    params
  }));

//票据打印预览
export const billPrintPerv = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/billprint/loadpayment/v2', Object.assign({}, options, {
    params
  }));

//票据号检测
export const checkPayBillNo = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/checkPayBillNo/v2', Object.assign(params, options));

//票据打印-打印
export const billPrint = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/submit/v2', Object.assign(params, options));

//获取账单列表
export const getFeeBillList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/list/v2', Object.assign({}, options, {
    params
  }));

//获取账单列表
export const getTemppayItemsetList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/temppay/itemset/list/v2', Object.assign({}, options, {
    params
  }));

//获取账单列表
export const getGenerateItemsetList = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/generate/itemset/list/v2', Object.assign({}, options, {
    params
  }));

//查询优惠券
export const queryCouponCode = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/queryCouponCode/v2', Object.assign({}, options, {
    params
  }));

//获取账单列表
export const getGenerateEnddate = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/generate/enddate/v2', Object.assign({}, options, {
    params
  }));

//获取账单列表
export const generateFeeBill = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/feeBill/generate/v2', Object.assign(params, options));

//获取账单列表
export const getTemppayInfo = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/temppay/info/v2', Object.assign({}, options, {
    params
  }));

//获取户主欠费金额
export const getArrearsExtendtion = (params, options) =>
  request.get('/api/v4ward/propertypay/v1/feeBill/arrears/v2', Object.assign({}, options, {
    params
  }));

//获取账单信息
export const getAccountSearch = (params = {}, options = {}) =>
  request.get('/api/v4ward/fund/bill/page/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取账单历史
export const getBillSearch = (params = {}, options = {}) =>
  request.get('/api/v4ward/fund/pay/historyPage/v2',
    Object.assign({}, options, {
      params
    })
  );

//获取户主房屋信息
export const getHouseholderRoomInfo = (params = {}, options = {}) =>
  request.get('/api/base/property/getHousenholdById/v2',
    Object.assign({}, options, {
      params
    })
  );

export const getStandardByTargetId = (params, options) =>
  request.get('/api/v4ward/fee/standard/listByTargetId/v2', Object.assign({}, options, {
    params
  }));


//临时收费二维码支付
export const saveQrCodePayTemp = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/temporarypay/v2', params, options);

//获取户主信息
export const getHouseholderInfo = (params = {}, options = {}) =>
  request.get('/api/base/household/getHouseholdByPropertyId/v2',
    Object.assign({}, options, {
      params
    })
  );

//票据打印预览
export const billPrintPervNew = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/billprint/loadpayment/v2', Object.assign({}, options, {
    params
  }));


//票据打印保存
export const billPrintSaveNew = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/save/v2', Object.assign(params, options));

//票据打印更新
export const billPrintUpdateNew = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/billprint/update/v2', Object.assign(params, options));

//获取优惠规则
export const getFavouredPolicy = (params = {}, options = {}) =>
  request.get('/api/v4ward/fund/preferent/gettPreferentList/v2',
    Object.assign({}, options, {
      params
    })
  );
//票据打印预览
export const getGenerateEnddateNew = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/getBillEndTime/v2', Object.assign({}, options, {
    params
  }));


//票据打印保存
export const generateFeeBillNew = (params, options) =>
  request.post('/api/v4ward/propertypay/v2/generateBill/v2', Object.assign(params, options));


//票据打印保存
// export const checkPayBillNoNew = (params, options) =>
//   request.post('/api/v4ward/propertypay/v2/billprint/checkPayBillNo', Object.assign(params, options));

//票据打印保存
export const checkPayBillNoNew = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/billprint/checkPayBillNo/v2', Object.assign({}, options, {
    params
  }));


//票据打印预览
export const calculatePreferent = (params, options) =>
  request.post('/api/v4ward/fund/preferent/calculate/v2', Object.assign(params, options));

//获取收费科目
export const getBindSubjectByTargetId = (params, options) =>
  request.get('/api/v4ward/fee/standard/bind/getBindSubjectByTargetId/v2', Object.assign({}, options, {
    params
  }));


//票据打印预览
export const billPayNewSubmit = (params, options) =>
  request.post('/api/v4ward/propertypay/v1/billpay/v2', Object.assign(params, options));


//获取收费科目
export const getBillAmountByFundStandardId = (params, options) =>
  request.get('/api/v4ward/propertypay/v2/getBillAmountByFundStandardId/v2', Object.assign({}, options, {
    params
  }));
